export enum CollectionName {
  COMPANIES = "companies",
  ITEM_LISTS = "itemLists",
  ITEMS = "items",
  SCAN_RESULTS = "scanResults",
  TOOL_TYPES = "toolTypes",
  VEHICLES = "vehicles",
  USERS = "users",
}
